import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useRef, useState } from 'react';
import { NavigationDataType, useNavigationData } from '@chegg-me-components/navigation-data';
import { initializeRioClient, nextCookies } from '@chegg-me-components/utils';
import { rioLoggingForClosingSelector, rioLoggingForLanguageSelected, rioLoggingForOpeningSelector } from '../rioLogging';
import { getCookieLangIndex, getDefaultLangIndex, saveLanguageCookie, useListboxBehaviour } from '../shared';
import { LanguageSelectorIcon } from '../shared/LanguageSelectorIcon';
import { LangSelectorWrapper, StyledListbox, StyledModal } from '../styles';

var LanguageSelectorModal = function LanguageSelectorModal(_ref) {
  var _ref$dataTest = _ref.dataTest,
      dataTest = _ref$dataTest === void 0 ? 'selector' : _ref$dataTest,
      languageProps = _ref.languageProps,
      clientEnv = _ref.clientEnv,
      _ref$defaultLocale = _ref.defaultLocale,
      defaultLocale = _ref$defaultLocale === void 0 ? 'en-US' : _ref$defaultLocale,
      rioConfig = _ref.rioConfig,
      cookieDomain = _ref.cookieDomain,
      signedIn = _ref.signedIn,
      oneGraphClient = _ref.oneGraphClient;
  var skipQuery = languageProps.length > 0;

  var _useNavigationData = useNavigationData({
    skipQuery: skipQuery,
    navigationDataType: NavigationDataType.LanguageSelector,
    clientEnv: clientEnv,
    useCache: false,
    // TODO: Check and add support for preview mode
    // isPreviewMode,
    // accessToken,
    oneGraphClient: oneGraphClient
  }),
      _useNavigationData$da = _useNavigationData.data,
      data = _useNavigationData$da === void 0 ? {
    children: [{
      language: '',
      langCode: '',
      langLocale: ''
    }]
  } : _useNavigationData$da;

  var selectorData = skipQuery ? languageProps : data.children;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var options = selectorData.map(function (lang) {
    return lang.language;
  }).filter(function (option) {
    return option;
  });
  var cookies = nextCookies().get(); // Finds if langPreference cookie is present. Returns -1 if not found.

  var cookieLangIndex = getCookieLangIndex(selectorData, cookies); // Finds the index of the locale passed as defaultLocale to the LanguageSelector package

  var defaultLocaleIndex = getDefaultLangIndex(selectorData, defaultLocale); // If locale from cookie dosen't match availabe locales, use the default locale .

  var activeIndex = cookieLangIndex === -1 ? Math.max(defaultLocaleIndex, 0) : cookieLangIndex;

  var _useState3 = useState(activeIndex),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedIndex = _useState4[0],
      setSelectedIndex = _useState4[1]; // Create ref for listbox component


  var listBoxRef = useRef(null);
  useEffect(function () {
    // Initialize Rio Client
    if (rioConfig) {
      initializeRioClient(rioConfig);
    }
  }, []);

  var onLanguageSelect = function onLanguageSelect(e) {
    setSelectedIndex(e);
    setIsModalOpen(!isModalOpen);
    selectedIndex !== e && saveLanguageCookie(selectorData[e].langLocale, cookieDomain);
    rioLoggingForLanguageSelected(selectorData, e);
  };

  var hasMounted = useRef(false);
  useEffect(function () {
    // skips rio logging for the first render
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }

    if (listBoxRef.current) {
      listBoxRef.current.focus();
    }
  }, [isModalOpen]);

  var _useListboxBehaviour = useListboxBehaviour(options, onLanguageSelect),
      pseudoFocusedListboxIndex = _useListboxBehaviour.pseudoFocusedListboxIndex,
      onListboxKeyDown = _useListboxBehaviour.onListboxKeyDown;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LangSelectorWrapper, {
    "data-test": "".concat(dataTest, "-wrapper"),
    onClick: function onClick() {
      setIsModalOpen(!isModalOpen);
      rioLoggingForOpeningSelector(selectorData);
    }
  }, /*#__PURE__*/React.createElement(LanguageSelectorIcon, {
    langCode: selectorData[selectedIndex].langCode,
    signedIn: signedIn
  })), /*#__PURE__*/React.createElement(StyledModal, {
    "aria-label": "Select Language",
    id: dataTest,
    isOpen: isModalOpen,
    onClose: function onClose() {
      setIsModalOpen(!isModalOpen);
      rioLoggingForClosingSelector();
    },
    contentOverflow: false,
    buttonAlignment: 'horizontal'
  }, /*#__PURE__*/React.createElement(StyledListbox, {
    "aria-label": "Select Language",
    ref: listBoxRef,
    inputId: dataTest,
    options: options,
    isOpen: true,
    pseudoFocusedIndex: pseudoFocusedListboxIndex,
    selectedIndex: selectedIndex,
    onSelectOption: onLanguageSelect,
    showCheckIcon: true,
    onKeyDown: onListboxKeyDown,
    tabIndex: -1
  })));
};

LanguageSelectorModal.displayName = 'LanguageSelectorModal';
export default LanguageSelectorModal;